import { render, staticRenderFns } from "./RecipeCardMeta.vue?vue&type=template&id=726a9385&"
import script from "./RecipeCardMeta.vue?vue&type=script&lang=js&"
export * from "./RecipeCardMeta.vue?vue&type=script&lang=js&"
import style0 from "./RecipeCardMeta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports